<template>
    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab
            active
            title="Dados"
        >
            <TabDados
                ref="TabDados"
                :data="data"
            />
        </rkm-tab>

        <rkm-tab title="Medicamentos">
            <TabMedicamentos
                ref="TabMedicamentos"
                :data="data"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import TabDados from './components/dado/Form'
import TabMedicamentos from './components/medicamento/Form'

export default {
    components: { TabDados, TabMedicamentos },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabDados,
            this.$refs.TabMedicamentos,
        ]
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>